import ApiClient from 'services/ApiClient';

import { OneClickPaymentParams } from 'types/payments';

import { SolidMerchantDataRequest, SolidMerchantDataResponse, SolidPostInitRequest } from '../types/payment';
import { IResultResponse } from '../types/response';

class PaymentApi {
    oneClickPayment = async <Data = OneClickPaymentParams, Response = IResultResponse>(
        payload: Data
    ): Promise<Partial<Response>> => {
        return await ApiClient.post<Data, Response>('payments/recurring', payload);
    };

    getSolidMerchantData = async <Data = SolidMerchantDataRequest, Response = SolidMerchantDataResponse>(
        payload: Data
    ): Promise<Partial<Response>> => {
        return await ApiClient.post<Data, Response>('payments/merchant-data', payload);
    };

    solidPostInit = async <Data = SolidPostInitRequest>(payload: Data): Promise<void> => {
        await ApiClient.post<Data, Response>('payments/post-init', payload);
    };
}

export default PaymentApi;
